import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import StockService from 'Service/stock';
import { Helmet } from 'react-helmet-async';
import Header from 'Container/stock/header';
import Search from 'Component/common/search';
import Info from 'Container/stock/info';
import Consensus from 'Container/stock/consensus';
import Attractive from 'Container/stock/attractive';
import FearGreed from 'Container/stock/fear_greed';
import TradeSignal from 'Container/stock/trade_signal';
import Howto from 'Container/stock/howto';
import Season from 'Container/stock/season';
import RelativeRate from 'Container/stock/relative_rate';
import FinancialStatements from 'Container/stock/financial_statements';
import Investor from 'Container/stock/investor';
import Qais from 'Container/stock/qais';
import Outline from 'Container/stock/outline';
import GuideStock from 'Component/guide/stock';
import EmptyStock from 'Component/empty_stock';

const Stock = () => {
  
  const { tickerDetail, ticker, hasLoadedTicker } = useSelector((state) => state.stock);

  const [showEmpty, setShowEmpty] = useState(false);

  useEffect(() => {
    let t;
    if (ticker && hasLoadedTicker && tickerDetail === null) {
      t = setTimeout(() => setShowEmpty(true), 300);
    } else {
      setShowEmpty(false);
    }
    return () => clearTimeout(t);
  }, [tickerDetail, ticker, hasLoadedTicker]);

  // StockService is a component that performs side-effect API calls; render it below

  return (
    <>
      <Helmet>
        <title>MTN 종목 분석</title>
        <meta name="description" content="여러분의 주식을 토브스탁 기업 분석으로 투자에 활용하세요." />
        <meta property="og:title" content="토브스탁 종목 분석" />
        <meta property="og:description" content="여러분의 주식을 토브스탁 기업 분석으로 투자에 활용하세요." />
        <meta property="og:image" content="https://img.finlit.co.kr/upload/meta/kr_home.jpg" />
      </Helmet>
      <div id="stock">
        <div className="container">
          <StockService />
          { tickerDetail && Number(tickerDetail.STK_TYP) === 1 &&
            <>
              <Info />
              <Consensus />
              <Attractive />
              <FearGreed />
              <TradeSignal />
              <Howto />
              <Season />
              <RelativeRate />
              <FinancialStatements />
              <Investor />
              <Qais />
              <Outline />
            </>
          }
          { tickerDetail && Number(tickerDetail.STK_TYP) === 2 && (
            <>
              <Info />
              <Attractive />
              <FearGreed />
              <TradeSignal />
              <Howto />
              <Season />
              <Outline />
            </>
          )}
          { showEmpty && <EmptyStock /> }
          <GuideStock />
        </div>
      </div>
    </>
  )
}

export default Stock;
